module.exports = __webpack_public_path__ + "static/img/pdd.8d7ae92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdd.png
// module id = R5fJ
// module chunks = 0